import React, { useRef } from "react";
import { Link } from "react-router-dom";

function ChangeOTP() {
  const inputsRef = useRef([]);
  const digitValidate = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  };

  const tabChange = (index) => {
    if (inputsRef.current[index] && inputsRef.current[index].value.length === 1) {
      if (inputsRef.current[index + 1]) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  return (
    <div style={{ minHeight: "auto" }}>
      <img src="images/org-img/sideimg.png" className="chngpassword-img" alt="" />

      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>

          <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
            {/* Same SVG inside */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>

          <Link to="" className="menu-item is-flex">
            {/* Same SVG */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>

          <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
            {/* Grid Icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center justify-self-center">
            <div className="me-auto">
              <img src="images/org-img/password.png" style={{ width: "17%" }} alt="" />
              <h2 className="me-h2 font-w600 mb-0">
                <b className="resetfont">OTP</b> Verification
              </h2>
              <p className="text-light">Lorem ipsum dolor sit amet</p>
            </div>
          </div>

          <div className="">
            <div className="row card-radius">
              <div className="">
                <div className="">
                  <div className="chng-word">
                    <div className="d-flex">
                      <div className="left1">
                        <div className="current-user">
                          <div className="">
                            <img className="avatar is-squared w-100" src="images/org-img/reset.svg" alt="" />
                          </div>
                        </div>
                      </div>

                      <div className="center01">
                        <form className="otpdiv">
                          {[0, 1, 2, 3].map((idx) => (
                            <input
                              key={idx}
                              className="otp"
                              type="text"
                              maxLength="1"
                              onInput={digitValidate}
                              onKeyUp={() => tabChange(idx)}
                              ref={(el) => (inputsRef.current[idx] = el)}
                            />
                          ))}
                          <div className="form-group mt-4"></div>
                        </form>

                        <button className="m-auto verifybtn">Verify</button>

                        <p className="codesend mt-5">
                          Didn't receive OTP? <Link to="">Resend OTP</Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ChangeOTP;
